import Accordion from 'accordion-js';

//find all HtmlHidden.ascx on the go page and add accordion script to each one
//pre-open the accordion defined in url else open the first one

const goPageAccordions = Array.from(document.querySelectorAll('.goAccordion'));

let docURL = document.URL;
let strID = docURL.substr(docURL.indexOf('#') + 1);
let isHashInUrl = strID && docURL != strID && strID.indexOf('/') == -1;
let isHashInPage = document.querySelector(`[hashtag="${strID}"]`);
if (isHashInUrl && isHashInPage) {
    for (var i = 0; i < goPageAccordions.length; i++) {
        //initialize each accordion on the page and keep open if specified in url
        new Accordion(goPageAccordions[i], {
            openOnInit: goPageAccordions[i].contains(isHashInPage) ? [0] : [],
            duration: 300,
            beforeOpen: function (currentElement) {
                setTimeout(() => {
                    window.scrollTo({
                        top: currentElement.getBoundingClientRect().top + window.scrollY,
                        behavior: 'smooth',
                    });
                }, 150);
            },
        });

        goPageAccordions[i].contains(isHashInPage)
            ? setTimeout(() => {
                  window.scrollTo({
                      top: isHashInPage.getBoundingClientRect().top + window.scrollY,
                      behavior: 'smooth',
                  });
              }, 150)
            : '';
    }
} else {
    for (var i = 0; i < goPageAccordions.length; i++) {
        //initialize each accordion on the page and open the first one
        new Accordion(goPageAccordions[i], {
            openOnInit: i == 0 ? [0] : [],
            duration: 300,
            beforeOpen: function (currentElement) {
                setTimeout(() => {
                    window.scrollTo({
                        top: currentElement.getBoundingClientRect().top + window.scrollY,
                        behavior: 'smooth',
                    });
                }, 150);
            },
        });
    }
}
